import { handleSystemErrorReport } from '@mb/lib/utils';

export const getAnalyticsDataIfCollection = () => {
  let finalAnalyticsId = 'catalog_all_products';
  let finalAnalyticsTitle = 'All products';

  try {
    const slug = window.location.pathname?.split('/')?.pop();
    const bannerText = slug?.split('-')?.slice(0, -1)?.join(' ');
    if (typeof bannerText === 'string') {
      const analyticsId =
        bannerText != null
          ? bannerText?.toLowerCase()?.replaceAll(' ', '_')
          : null;
      finalAnalyticsId =
        analyticsId != null
          ? `collections_${analyticsId}`
          : 'catalog_all_products';
      finalAnalyticsTitle = `collections ${bannerText}` || 'All products';
    }
    return { id: finalAnalyticsId, title: finalAnalyticsTitle };
  } catch (e) {
    console.log(e);
    handleSystemErrorReport(
      `Error getAnalyticsDataIfCollection: ${e.message}`,
      'getAnalyticsDataIfCollection',
    );
    return { id: finalAnalyticsId, title: finalAnalyticsTitle };
  }
};
